var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherFunds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "other-funds_svg__a5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "other-funds_svg__a5",
    d: "M0 0h35.497v40.098H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".other-funds_svg__a5{fill:#979797}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.002 4)",
    clipPath: "url(#other-funds_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "other-funds_svg__a5",
    d: "M28.216 32.34a15.05 15.05 0 11-18.19-21.48L7.31.633a.5.5 0 01.49-.634h14.5a.5.5 0 01.487.633L20.071 10.86a15.11 15.11 0 017.629 6.032.504.504 0 01-.846.547 14.092 14.092 0 00-7.539-5.772.5.5 0 01-.334-.609l2.668-10.05h-6.097v4.32a.503.503 0 11-1.007 0V1.007H8.452l2.668 10.05a.5.5 0 01-.334.609 14.043 14.043 0 1016.549 20.185.504.504 0 01.881.489m7.284-7.741a5.9 5.9 0 11-5.9-5.9 5.911 5.911 0 015.9 5.9m-1.007 0a4.9 4.9 0 10-4.9 4.9 4.9 4.9 0 004.9-4.9M32.3 22.637a.5.5 0 00-.711.05l-2.622 3.018-1.317-1.493a.503.503 0 10-.755.666l1.7 1.924a.5.5 0 00.378.17.5.5 0 00.378-.173l3-3.452a.5.5 0 00-.05-.711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.263 18.883h-9.5v1.888h3.35a2.836 2.836 0 012.669 1.888h-6.02v1.887h6.02a2.836 2.836 0 01-2.669 1.888h-3.35v1.891l5.532 5.532 1.335-1.335-4.2-4.2h.681a4.727 4.727 0 004.624-3.775h1.526v-1.888h-1.526a4.7 4.7 0 00-.851-1.888h2.377z",
    fill: "#97144d"
  }))));
}
export default SvgOtherFunds;